import { useMemo, useState } from "react";
import { Search, Layers } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Panel } from "@/components/core/AppLayout";
import { eur } from "@/lib/invoices";

const Item = ({ active, onClick, title, sub, badge, testid }) => (
  <button onClick={onClick} data-testid={testid}
    className={`w-full text-left rounded-xl px-3 py-2.5 transition-colors ${active ? "bg-[#0A1128] text-white" : "hover:bg-[#A6DAFC] text-[#0A1128]"}`}>
    <div className="flex items-center justify-between gap-2"><span className="font-bold text-sm truncate">{title}</span>{badge}</div>
    {sub && <div className={`text-xs mt-0.5 ${active ? "text-white/75" : "text-slate-600"}`}>{sub}</div>}
  </button>
);

export const InvoiceClientRail = ({ clients, selected, onSelect }) => {
  const [q, setQ] = useState("");
  const list = useMemo(() => (clients || []).filter((c) => c.ragione_sociale.toLowerCase().includes(q.trim().toLowerCase())), [clients, q]);
  return (
    <Panel className="p-3 sticky top-6 max-h-[calc(100vh-3rem)] flex flex-col" data-testid="inv-client-rail">
      <div className="relative mb-2"><Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-500" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca cliente" className="rounded-full pl-9 bg-white" data-testid="inv-client-search" /></div>
      <Item active={selected === "all"} onClick={() => onSelect("all")} testid="inv-client-all"
        title={<span className="inline-flex items-center gap-1.5"><Layers className="h-4 w-4" />Tutti i clienti</span>} sub="Riepilogo e tabella completa" />
      <div className="h-px bg-[#5FB3EA] my-2" />
      <div className="overflow-y-auto core-scroll space-y-1 pr-1">
        {list.map((c) => (
          <Item key={c.id} active={selected === c.id} onClick={() => onSelect(c.id)} testid={`inv-client-${c.id}`} title={c.ragione_sociale}
            sub={c.da_incassare > 0 ? `Da incassare ${eur(c.da_incassare)}` : c.fatture ? "Tutto incassato" : "Nessuna fattura"}
            badge={<span className={`shrink-0 text-[11px] font-bold rounded-full px-2 py-0.5 ${c.scadute ? "bg-[#E8173A] text-white" : selected === c.id ? "bg-white/20" : "bg-white/70"}`}
              title={c.scadute ? `${c.scadute} scadute` : undefined} data-testid={`inv-client-count-${c.id}`}>{c.fatture}</span>} />
        ))}
        {clients && !list.length && <div className="text-sm text-slate-600 px-3 py-4" data-testid="inv-client-empty">Nessun cliente attivo trovato.</div>}
      </div>
    </Panel>
  );
};
